const country = [
  { key: "00", label: "Select country" },
  { key: "AD", label: "Andorra" },
  { key: "AE", label: "United Arab Emirates" },
  { key: "AF", label: "Afghanistan" },
  { key: "AG", label: "Antigua and Barbuda" },
  { key: "AI", label: "Anguilla" },
  { key: "AL", label: "Albania" },
  { key: "AM", label: "Armenia" },
  { key: "AN", label: "Netherlands Antilles" },
  { key: "AO", label: "Angola" },
  { key: "AQ", label: "Antarctica" },
  { key: "AR", label: "Argentina" },
  { key: "AS", label: "American Samoa" },
  { key: "AT", label: "Austria" },
  { key: "AU", label: "Australia" },
  { key: "AW", label: "Aruba" },
  { key: "AX", label: "Aland Islands" },
  { key: "AZ", label: "Azerbaijan" },
  { key: "BA", label: "Bosnia and Herzegovina" },
  { key: "BB", label: "Barbados" },
  { key: "BD", label: "Bangladesh" },
  { key: "BE", label: "Belgium" },
  { key: "BF", label: "Burkina Faso" },
  { key: "BG", label: "Bulgaria" },
  { key: "BH", label: "Bahrain" },
  { key: "BI", label: "Burundi" },
  { key: "BJ", label: "Benin" },
  { key: "BL", label: "Saint Barthelemy" },
  { key: "BM", label: "Bermuda" },
  { key: "BN", label: "Brunei Darussalam" },
  { key: "BO", label: "Bolivia" },
  { key: "BQ", label: "Bonaire" },
  { key: "BR", label: "Brazil" },
  { key: "BS", label: "Bahamas" },
  { key: "BT", label: "Bhutan" },
  { key: "BV", label: "Bouvet Island" },
  { key: "BW", label: "Botswana" },
  { key: "BY", label: "Belarus" },
  { key: "BZ", label: "Belize" },
  { key: "CA", label: "Canada" },
  { key: "CC", label: "Cocos (Keeling) Islands" },
  { key: "CD", label: "Democratic Republic of the Congo" },
  { key: "CF", label: "Central African Republic" },
  { key: "CG", label: "Congo" },
  { key: "CH", label: "Switzerland" },
  { key: "CK", label: "Cook Islands" },
  { key: "CL", label: "Chile" },
  { key: "CM", label: "Cameroon" },
  { key: "CN", label: "China" },
  { key: "CO", label: "Colombia" },
  { key: "CR", label: "Costa Rica" },
  { key: "CU", label: "Cuba" },
  { key: "CV", label: "Cape Verde" },
  { key: "CX", label: "Christmas Island" },
  { key: "CY", label: "Cyprus" },
  { key: "CZ", label: "Czech Republic" },
  { key: "DE", label: "Germany" },
  { key: "DJ", label: "Djibouti" },
  { key: "DK", label: "Denmark" },
  { key: "DM", label: "Dominica" },
  { key: "DO", label: "Dominican Republic" },
  { key: "DZ", label: "Algeria" },
  { key: "EC", label: "Ecuador" },
  { key: "EE", label: "Estonia" },
  { key: "EG", label: "Egypt" },
  { key: "EH", label: "Western Sahara" },
  { key: "ER", label: "Eritrea" },
  { key: "ET", label: "Ethiopia" },
  { key: "ET", label: "Ethiopia" },
  { key: "FI", label: "Finland" },
  { key: "FJ", label: "Fiji" },
  { key: "FK", label: "Falkland Islands (Malvinas)" },
  { key: "FM", label: "Federated States of Micronesia" },
  { key: "FO", label: "Faroe Islands" },
  { key: "FR", label: "France" },
  { key: "FX", label: "France, Metropolitan" },
  { key: "GA", label: "Gabon" },
  { key: "GB", label: "Great Britain (UK)" },
  { key: "GD", label: "Grenada" },
  { key: "GE", label: "Georgia" },
  { key: "GF", label: "French Guiana" },
  { key: "GH", label: "Ghana" },
  { key: "GI", label: "Gibraltar" },
  { key: "GL", label: "Greenland" },
  { key: "GM", label: "Gambia" },
  { key: "GN", label: "Guinea" },
  { key: "GP", label: "Guadeloupe" },
  { key: "GQ", label: "Equatorial Guinea" },
  { key: "GR", label: "Greece" },
  { key: "GS", label: "S. Georgia and S. Sandwich Islands" },
  { key: "GT", label: "Guatemala" },
  { key: "GU", label: "Guam" },
  { key: "GW", label: "Guinea-Bissau" },
  { key: "GY", label: "Guyana" },
  { key: "HK", label: "Hong Kong" },
  { key: "HM", label: "Heard Island and McDonald Islands" },
  { key: "HN", label: "Honduras" },
  { key: "HR", label: "Croatia (Hrvatska)" },
  { key: "HT", label: "Haiti" },
  { key: "HU", label: "Hungary" },
  { key: "ID", label: "Indonesia" },
  { key: "IE", label: "Ireland" },
  { key: "IL", label: "Israel" },
  { key: "IN", label: "India" },
  { key: "IO", label: "British Indian Ocean Territory" },
  { key: "IQ", label: "Iraq" },
  { key: "IR", label: "Iran" },
  { key: "IS", label: "Iceland" },
  { key: "IT", label: "Italy" },
  { key: "JM", label: "Jamaica" },
  { key: "JO", label: "Jordan" },
  { key: "JP", label: "Japan" },
  { key: "KE", label: "Kenya" },
  { key: "KG", label: "Kyrgyzstan" },
  { key: "KH", label: "Cambodia" },
  { key: "KI", label: "Kiribati" },
  { key: "KM", label: "Comoros" },
  { key: "KN", label: "Saint Kitts and Nevis" },
  { key: "KP", label: "Korea (North)" },
  { key: "KR", label: "Korea (South)" },
  { key: "KW", label: "Kuwait" },
  { key: "KY", label: "Cayman Islands" },
  { key: "KZ", label: "Kazakhstan" },
  { key: "LA", label: "Laos" },
  { key: "LB", label: "Lebanon" },
  { key: "LC", label: "Saint Lucia" },
  { key: "LI", label: "Liechtenstein" },
  { key: "LK", label: "Sri Lanka" },
  { key: "LR", label: "Liberia" },
  { key: "LS", label: "Lesotho" },
  { key: "LT", label: "Lithuania" },
  { key: "LU", label: "Luxembourg" },
  { key: "LV", label: "Latvia" },
  { key: "LY", label: "Libya" },
  { key: "MA", label: "Morocco" },
  { key: "MC", label: "Monaco" },
  { key: "MD", label: "Moldova" },
  { key: "ME", label: "Montenegro" },
  { key: "MG", label: "Madagascar" },
  { key: "MH", label: "Marshall Islands" },
  { key: "MK", label: "Macedonia" },
  { key: "ML", label: "Mali" },
  { key: "MM", label: "Myanmar" },
  { key: "MN", label: "Mongolia" },
  { key: "MO", label: "Macao" },
  { key: "MP", label: "Northern Mariana Islands" },
  { key: "MQ", label: "Martinique" },
  { key: "MR", label: "Mauritania" },
  { key: "MS", label: "Montserrat" },
  { key: "MT", label: "Malta" },
  { key: "MU", label: "Mauritius" },
  { key: "MV", label: "Maldives" },
  { key: "MW", label: "Malawi" },
  { key: "MX", label: "Mexico" },
  { key: "MY", label: "Malaysia" },
  { key: "MZ", label: "Mozambique" },
  { key: "NA", label: "Namibia" },
  { key: "NC", label: "New Caledonia" },
  { key: "NE", label: "Niger" },
  { key: "NF", label: "Norfolk Island" },
  { key: "NG", label: "Nigeria" },
  { key: "NI", label: "Nicaragua" },
  { key: "NL", label: "Netherlands" },
  { key: "NO", label: "Norway" },
  { key: "NP", label: "Nepal" },
  { key: "NR", label: "Nauru" },
  { key: "NU", label: "Niue" },
  { key: "NZ", label: "New Zealand (Aotearoa)" },
  { key: "OM", label: "Oman" },
  { key: "PA", label: "Panama" },
  { key: "PE", label: "Peru" },
  { key: "PF", label: "French Polynesia" },
  { key: "PG", label: "Papua New Guinea" },
  { key: "PK", label: "Pakistan" },
  { key: "PL", label: "Poland" },
  { key: "PN", label: "Pitcairn" },
  { key: "PR", label: "Puerto Rico" },
  { key: "PS", label: "Palestinian Territory" },
  { key: "PT", label: "Portugal" },
  { key: "PW", label: "Palau" },
  { key: "PY", label: "Paraguay" },
  { key: "PH", label: "Philippines" },
  { key: "QA", label: "Qatar" },
  { key: "RE", label: "Reunion" },
  { key: "RO", label: "Romania" },
  { key: "RS", label: "Serbia" },
  { key: "RU", label: "Russian Federation" },
  { key: "RW", label: "Rwanda arrivia Partner API Suite" },
  { key: "SA", label: "Saudi Arabia" },
  { key: "SB", label: "Solomon Islands" },
  { key: "SC", label: "Seychelles" },
  { key: "SD", label: "Sudan" },
  { key: "SE", label: "Sweden" },
  { key: "SG", label: "Singapore" },
  { key: "SH", label: "Saint Helena" },
  { key: "SI", label: "Slovenia" },
  { key: "SK", label: "Slovakia" },
  { key: "SL", label: "Sierra Leone" },
  { key: "SM", label: "San Marino" },
  { key: "SN", label: "Senegal" },
  { key: "SO", label: "Somalia" },
  { key: "SR", label: "Suriname" },
  { key: "ST", label: "Sao Tome and Principe" },
  { key: "SU", label: "USSR (former)" },
  { key: "SV", label: "El Salvador" },
  { key: "SX", label: "Sint Maarten" },
  { key: "SY", label: "Syria" },
  { key: "SZ", label: "Swaziland" },
  { key: "TC", label: "Turks and Caicos Islands" },
  { key: "TD", label: "Chad" },
  { key: "TF", label: "French Southern Territories" },
  { key: "TG", label: "Togo" },
  { key: "TH", label: "Thailand" },
  { key: "TJ", label: "Tajikistan" },
  { key: "TK", label: "Tokelau" },
  { key: "TL", label: "Timor-Leste" },
  { key: "TM", label: "Turkmenistan" },
  { key: "TN", label: "Tunisia" },
  { key: "TO", label: "Tonga" },
  { key: "TP", label: "East Timor" },
  { key: "TR", label: "Turkey" },
  { key: "TT", label: "Trinidad and Tobago" },
  { key: "TV", label: "Tuvalu" },
  { key: "TW", label: "Taiwan" },
  { key: "TZ", label: "Tanzania" },
  { key: "UA", label: "Ukraine" },
  { key: "UG", label: "Uganda" },
  { key: "UK", label: "United Kingdom" },
  { key: "US", label: "United States" },
  { key: "UY", label: "Uruguay" },
  { key: "UZ", label: "Uzbekistan" },
  { key: "VC", label: "Saint Vincent and the Grenadines" },
  { key: "VE", label: "Venezuela" },
  { key: "VG", label: "Virgin Islands" },
  { key: "VI", label: "Virgin Islands (U.S.)" },
  { key: "VN", label: "Vietnam" },
  { key: "VU", label: "Vanuatu" },
  { key: "WF", label: "Wallis and Futuna" },
  { key: "WS", label: "Samoa" },
  { key: "YE", label: "Yemen" },
  { key: "YT", label: "Mayotte" },
  { key: "YU", label: "Yugoslavia (former)" },
  { key: "ZA", label: "South Africa" },
  { key: "ZM", label: "Zambia" },
  { key: "ZR", label: "Zaire (former)" },
  { key: "ZW", label: "Zimbabwe" },
];
export default country;
